[
  {
    "code": "UA-71",
    "name": "Cherkas'ka Oblast'"
  },
  {
    "code": "UA-74",
    "name": "Chernihivs'ka Oblast'"
  },
  {
    "code": "UA-77",
    "name": "Chernivets'ka Oblast'"
  },
  {
    "code": "UA-12",
    "name": "Dnipropetrovs'ka Oblast'"
  },
  {
    "code": "UA-14",
    "name": "Donets'ka Oblast'"
  },
  {
    "code": "UA-26",
    "name": "Ivano-Frankivs'ka Oblast'"
  },
  {
    "code": "UA-63",
    "name": "Kharkivs'ka Oblast'"
  },
  {
    "code": "UA-65",
    "name": "Khersons'ka Oblast'"
  },
  {
    "code": "UA-68",
    "name": "Khmel'nyts'ka Oblast'"
  },
  {
    "code": "UA-35",
    "name": "Kirovohrads'ka Oblast'"
  },
  {
    "code": "UA-30",
    "name": "Kyïv"
  },
  {
    "code": "UA-32",
    "name": "Kyïvs'ka Oblast'"
  },
  {
    "code": "UA-46",
    "name": "L'vivs'ka Oblast'"
  },
  {
    "code": "UA-09",
    "name": "Luhans'ka Oblast'"
  },
  {
    "code": "UA-48",
    "name": "Mykolaïvs'ka Oblast'"
  },
  {
    "code": "UA-51",
    "name": "Odes'ka Oblast'"
  },
  {
    "code": "UA-53",
    "name": "Poltavs'ka Oblast'"
  },
  {
    "code": "UA-43",
    "name": "Respublika Krym"
  },
  {
    "code": "UA-56",
    "name": "Rivnens'ka Oblast'"
  },
  {
    "code": "UA-40",
    "name": "Sevastopol'"
  },
  {
    "code": "UA-59",
    "name": "Sums'ka Oblast'"
  },
  {
    "code": "UA-61",
    "name": "Ternopil's'ka Oblast'"
  },
  {
    "code": "UA-05",
    "name": "Vinnyts'ka Oblast'"
  },
  {
    "code": "UA-07",
    "name": "Volyns'ka Oblast'"
  },
  {
    "code": "UA-21",
    "name": "Zakarpats'ka Oblast'"
  },
  {
    "code": "UA-23",
    "name": "Zaporiz'ka Oblast'"
  },
  {
    "code": "UA-18",
    "name": "Zhytomyrs'ka Oblast'"
  }
]